import { useNavigate } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface DeleteModalProps {
  title: string
  onSubmit: () => Promise<void>
  onClosePath: string
  cancelPath: string
  description: string
}

const DeleteModal = ({
  title,
  onSubmit,
  onClosePath,
  cancelPath,
  description,
}: DeleteModalProps) => {
  const navigate = useNavigate()

  return (
    <Modal
      title={title}
      description={description}
      onSubmit={onSubmit}
      onClose={() => navigate(onClosePath)}
      illustration="delete"
      footer={
        <>
          <Button.Router to={cancelPath}>
            {i18n.t('trainings.trainings_revamp.delete_event_modal.cancel')}
          </Button.Router>
          <Button type="negative" submit>
            {i18n.t('trainings.trainings_revamp.delete_event_modal.submit')}
          </Button>
        </>
      }
    ></Modal>
  )
}

export default DeleteModal
